var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.798 4.503.001.001a.41.41 0 0 1 0 .705l-6.68 3.947A.41.41 0 0 1 .5 8.804V.908C.5.711.592.603.706.547a.446.446 0 0 1 .413.008l6.679 3.948Z",
    stroke: "#D7D9DB"
  })));
};
export default SvgPlay;